import type { CallContextValue } from 'src/types/call';

import { createContext } from 'react';

// ----------------------------------------------------------------------

export const CallContext = createContext<CallContextValue | undefined>(undefined);
